import React from "react";
import * as Yup from 'yup';
import { TechnicianData } from "../../generated"

import { Forms } from "../../common/components/CmForms";
import ColorInput from "../../common/components/colorInput";
const { Form, FormText, ActionBar } = Forms<TechnicianData>()

interface Props {
    technician?: TechnicianData;
    onSubmit: (caldaia: TechnicianData) => void;
    onCancel: () => void;
}

export default class TechnicianForm extends React.Component<Props> {

    private static validationSchema = Yup.object<Partial<TechnicianData>>({
        firstName: Yup
            .string()
            .required('Campo obbligatorio'),
        lastName: Yup
            .string()
            .required('Campo obbligatorio'),
    })

    render() {
        const { technician } = this.props;
        if (!technician)
            return null;
        return (
            <Form
                onSubmit={this.props.onSubmit}
                initialValues={technician}
                validationSchema={TechnicianForm.validationSchema}
            >
                {
                    ({ values, set, errors }) =>
                        <div className="card card-outline-info">
                            <div className="card-header text-white">Dati Tecnico</div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-12 col-md-2">
                                        <ColorInput
                                            onChange={color => set("color", color)}
                                            label="Colore"
                                            name="color"
                                            value={values.color ?? null}
                                        />
                                    </div>
                                    <div className="col-12 col-md-5">
                                        <FormText
                                            name="firstName"
                                            label="Nome"
                                        />
                                    </div>
                                    <div className="col-12 col-md-5">
                                        <FormText
                                            name="lastName"
                                            label="Cognome"
                                        />
                                    </div>
                                    < div className="col-12">
                                        <FormText
                                            name="calendarLink"
                                            label="Link calendario esterno"
                                            readOnly
                                            disabled
                                        />
                                    </div>
                                </div>
                                <ActionBar
                                    onCancel={this.props.onCancel}
                                />
                            </div>
                        </div>
                }
            </Form>
        );
    }
}
